module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-01-jp.05c762b9f95d6101ffaa3a1451e3d5c5.png";